module.exports = __webpack_public_path__ + "static/media/apple-ios.63b97d1f.svg";